import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const EducationCredentials = () => {
  const education = [
    {
      degree: 'Bachelor of Commerce',
      institution: 'VNSGU, Surat',
      location: 'Surat, Gujarat',
      period: '2019 - 2022',
      gpa: '7.5/10',
      logo: 'https://images.unsplash.com/photo-1562774053-701939374585?w=100&h=100&fit=crop',
      highlights: [
        'Strong foundation in business principles and commerce',
        'Developed analytical and problem-solving skills',
        'Understanding of market dynamics and business operations',
        'Project work on business case studies and financial analysis'
      ],
      relevantCourses: [
        'Business Mathematics',
        'Financial Accounting',
        'Business Economics',
        'Marketing Management',
        'Business Communication',
        'Commercial Law'
      ]
    },
    {
      degree: 'Full Stack Web Development Bootcamp',
      institution: 'Iqonic Design',
      location: 'Surat, Gujarat',
      period: '2021',
      gpa: null,
      logo: 'https://media.istockphoto.com/id/2174465160/photo/digital-collaboration-blonde-businesswoman-and-african-american-partner-reviewing-documents.jpg?s=612x612&w=0&k=20&c=yaPw4ceFaqYNUHPf7MHGMAra54WB6FoUDqs9rTwhF0k=',
      highlights: [
        'Intensive 12-week program',
        'Top 10% of cohort performance',
        'Built 5 full-stack applications',
        'Collaborated on team projects using Agile methodology'
      ],
      relevantCourses: [
        'React & Redux',
        'Node.js & Express',
        'MongoDB & PostgreSQL',
        'RESTful APIs',
        'Git & GitHub',
        'Deployment & DevOps'
      ]
    }
  ];

  const certifications = [
    {
      name: 'Backend Development Certificate',
      issuer: 'NSDC (National Skill Development Corporation)',
      date: '2022',
      credentialId: 'NSDC-BE-2022',
      logo: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=60&h=60&fit=crop',
      skills: ['HTML/CSS', 'JavaScript', 'Node.js', 'Express.js', 'MongoDB', 'REST APIs', 'Database Design']
    },
    {
      name: 'Internship Certificate',
      issuer: 'Iqonic Design',
      date: '2021',
      credentialId: 'IQONIC-INTERN-2021',
      logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=60&h=60&fit=crop',
      skills: ['MERN Stack', 'WordPress Development', 'SaaS Development', 'Client Projects', 'Team Collaboration']
    }
  ];


  return (
    <div className="space-y-8">
      {/* Education Section */}
      <div className="bg-surface rounded-lg p-4 sm:p-6 shadow-md border border-border overflow-hidden">
        <div className="flex items-center mb-6">
          <Icon name="GraduationCap" size={24} className="text-primary mr-3" />
          <h2 className="text-2xl font-bold text-text-primary">Education</h2>
        </div>

        <div className="space-y-6">
          {education.map((edu, index) => (
            <div key={index} className="border-l-4 border-primary pl-4 sm:pl-6">
              <div className="flex items-start space-x-3 sm:space-x-4 mb-4">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg overflow-hidden flex-shrink-0">
                  <Image
                    src={edu.logo}
                    alt={`${edu.institution} logo`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base sm:text-lg font-semibold text-text-primary break-words">{edu.degree}</h3>
                  <p className="text-primary font-medium break-words">{edu.institution}</p>
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs sm:text-sm text-text-secondary mt-1">
                    <div className="flex items-center">
                      <Icon name="MapPin" size={14} className="mr-1 flex-shrink-0" />
                      {edu.location}
                    </div>
                    <div className="flex items-center">
                      <Icon name="Calendar" size={14} className="mr-1 flex-shrink-0" />
                      {edu.period}
                    </div>
                    {edu.gpa && (
                      <div className="flex items-center">
                        <Icon name="Award" size={14} className="mr-1 flex-shrink-0" />
                        GPA: {edu.gpa}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Highlights */}
              <div className="mb-4">
                <h4 className="font-semibold text-text-primary mb-2">Highlights</h4>
                <ul className="space-y-1">
                  {edu.highlights.map((highlight, highlightIndex) => (
                    <li key={highlightIndex} className="flex items-start">
                      <Icon name="CheckCircle" size={14} className="text-success mr-2 mt-0.5 flex-shrink-0" />
                      <span className="text-text-secondary text-sm">{highlight}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Relevant Courses */}
              <div>
                <h4 className="font-semibold text-text-primary mb-2">Relevant Coursework</h4>
                <div className="flex flex-wrap gap-2">
                  {edu.relevantCourses.map((course, courseIndex) => (
                    <span key={courseIndex} className="px-2 py-1 bg-primary/10 text-primary rounded text-xs font-medium">
                      {course}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Certifications Section */}
      <div className="bg-surface rounded-lg p-4 sm:p-6 shadow-md border border-border overflow-hidden">
        <div className="flex items-center mb-6">
          <Icon name="Award" size={24} className="text-primary mr-3" />
          <h2 className="text-2xl font-bold text-text-primary">Professional Certifications</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4 sm:gap-6">
          {certifications.map((cert, index) => (
            <div key={index} className="bg-muted rounded-lg p-3 sm:p-4 hover:shadow-md transition-shadow duration-200 overflow-hidden">
              <div className="flex items-start space-x-3 mb-3">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg overflow-hidden flex-shrink-0">
                  <Image
                    src={cert.logo}
                    alt={`${cert.issuer} logo`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-text-primary text-xs sm:text-sm break-words">{cert.name}</h3>
                  <p className="text-primary text-xs sm:text-sm font-medium break-words">{cert.issuer}</p>
                  <div className="flex items-center text-xs text-text-secondary mt-1">
                    <Icon name="Calendar" size={12} className="mr-1 flex-shrink-0" />
                    {cert.date}
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <p className="text-xs text-text-secondary">
                  <span className="font-medium">Credential ID:</span> {cert.credentialId}
                </p>
              </div>

              <div>
                <h4 className="text-xs font-semibold text-text-primary mb-2">Skills Validated</h4>
                <div className="flex flex-wrap gap-1">
                  {cert.skills.map((skill, skillIndex) => (
                    <span key={skillIndex} className="px-2 py-1 bg-accent/10 text-accent rounded text-xs">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Academic Achievements */}
      <div className="bg-surface rounded-lg p-4 sm:p-6 shadow-md border border-border overflow-hidden">
        <div className="flex items-center mb-4">
          <Icon name="Trophy" size={24} className="text-primary mr-3" />
          <h2 className="text-2xl font-bold text-text-primary">Academic Achievements</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
          <div className="text-center p-3 sm:p-4 bg-muted rounded-lg">
            <Icon name="Award" size={32} className="text-success mx-auto mb-2" />
            <div className="text-base sm:text-lg font-bold text-text-primary">7.5/10 GPA</div>
            <div className="text-xs sm:text-sm text-text-secondary break-words">VNSGU BCOM Graduate</div>
          </div>
          
          <div className="text-center p-3 sm:p-4 bg-muted rounded-lg">
            <Icon name="TrendingUp" size={32} className="text-primary mx-auto mb-2" />
            <div className="text-base sm:text-lg font-bold text-text-primary">Business Focus</div>
            <div className="text-xs sm:text-sm text-text-secondary break-words">Commerce & Economics</div>
          </div>
          
          <div className="text-center p-3 sm:p-4 bg-muted rounded-lg">
            <Icon name="Calculator" size={32} className="text-accent mx-auto mb-2" />
            <div className="text-base sm:text-lg font-bold text-text-primary">Analytical Skills</div>
            <div className="text-xs sm:text-sm text-text-secondary break-words">Financial & Business</div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default EducationCredentials;